<template>
  <div class="index spebgc" style="width:100%">
    <Header title=""></Header>
    <div style="position:relative">
        <div v-if="showYTReturn" class="ytclose" @click='retrunHome()'>{{$t('m.ReturnToUnifiedLoginPlatform')}}</div>
      <!-- 竖屏 -->
      <div class="warp" v-if="this.$store.state.Screenstatus">
        <div class="warpcentent wcolor" id="warpcontent">
          <div :class="{menu:true,grebgc:true,center:move==1,left:move==0}">
            <div @click="toanpai()" class="menuitem">
              <img :src="imgpath.meeting" alt />
              <span>{{$t('m.PlanMeeting')}}</span>
            </div>
            <div @click="tomeeting()" class="menuitem">
              <img :src="imgpath.control" alt />
              <span>{{$t('m.ControlMeeting')}}</span>
            </div>
            <div @click="toattendmeeetlist()" class="menuitem">
              <img :src="imgpath.agreement" alt />
              <span>{{$t('m.AppointManagement')}}</span>
            </div>
            <div @click="tohistory()" class="menuitem">
              <img :src="imgpath.history" alt />
              <span>{{$t('m.HistoryMeeting')}}</span>
            </div>
          </div>
          <div :class="{menu:true,grebgc:true,center:move==2,left:move==1}">
            <div @click="tohistoryplaymeeting()" class="menuitem">
              <img :src="imgpath.scan" alt />
              <span>{{$t('m.ConferenceOnDemand')}}</span>
            </div>
            <div @click="tochoicepeople()" class="menuitem">
              <img :src="imgpath.linklist" alt />
              <span>{{$t('m.Address')}}</span>
            </div>
            <div @click="tomeetingtemplate()" class="menuitem">
              <img :src="imgpath.meetingtemplate" alt />
              <span>{{$t('m.MeetingTemplate')}}</span>
            </div>
            <div @click="toterminalcontrol()" class="menuitem">
              <img :src="imgpath.terminalcontrol" alt />
              <span>{{$t('m.TerminalMangerment')}}</span>
            </div>
          </div>
          <div :class="{menu:true,grebgc:true,center:move==3,left:move==2}">
            <div @click="toanpai()" class="menuitem">
              <img :src="imgpath.meeting" alt />
              <span>{{$t('m.PlanMeeting')}}</span>
            </div>
            <div @click="tomeeting()" class="menuitem">
              <img :src="imgpath.control" alt />
              <span>{{$t('m.ControlMeeting')}}</span>
            </div>
            <div @click="toattendmeeetlist()" class="menuitem">
              <img :src="imgpath.agreement" alt />
              <span>{{$t('m.AppointManagement')}}</span>
            </div>
            <div @click="tohistory()" class="menuitem">
              <img :src="imgpath.history" alt />
              <span>{{$t('m.HistoryMeeting')}}</span>
            </div>
          </div>
          <div :class="{menu:true,grebgc:true,center:move==0,left:move==3}">
            <div @click="tohistoryplaymeeting()" class="menuitem">
              <img :src="imgpath.scan" alt />
              <span>{{$t('m.ConferenceOnDemand')}}</span>
            </div>
            <div @click="tochoicepeople()" class="menuitem">
              <img :src="imgpath.linklist" alt />
              <span>{{$t('m.Address')}}</span>
            </div>
            <div @click="tomeetingtemplate()" class="menuitem">
              <img :src="imgpath.meetingtemplate" alt />
              <span>{{$t('m.MeetingTemplate')}}</span>
            </div>
            <div @click="toterminalcontrol()" class="menuitem">
              <img :src="imgpath.terminalcontrol" alt />
              <span>{{$t('m.TerminalMangerment')}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 横屏 -->
      <div class="lancewarp" v-else>
        <div class="warpcentent wcolor" id="warpcontent">
          <div class="menu,grebgc">
            <div @click="toanpai()" class="menuitem fistmenuitem">
              <img :src="imgpath.meeting" alt />
              <span>{{$t('m.PlanMeeting')}}</span>
            </div>
            <div @click="tomeeting()" class="menuitem">
              <img :src="imgpath.control" alt />
              <span>{{$t('m.ControlMeeting')}}</span>
            </div>
            <div @click="toattendmeeetlist()" class="menuitem">
              <img :src="imgpath.agreement" alt />
              <span>{{$t('m.AppointManagement')}}</span>
            </div>
            <div @click="tohistory()" class="menuitem">
              <img :src="imgpath.history" alt />
              <span>{{$t('m.HistoryMeeting')}}</span>
            </div>
            <div @click="tohistoryplaymeeting()" class="menuitem">
              <img :src="imgpath.scan" alt />
              <span>{{$t('m.ConferenceOnDemand')}}</span>
            </div>
            <div @click="tochoicepeople()" class="menuitem">
              <img :src="imgpath.linklist" alt />
              <span>{{$t('m.Address')}}</span>
            </div>
            <div @click="tomeetingtemplate()" class="menuitem">
              <img :src="imgpath.meetingtemplate" alt />
              <span>{{$t('m.TerminalMangerment')}}</span>
            </div>
            <div @click="toterminalcontrol()" class="menuitem">
              <img :src="imgpath.terminalcontrol" alt />
              <span>{{$t('m.TerminalMangerment')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div :class="{contentitem:true,ge:!meeting.length}" style="margin-top:0.1rem">
        <div @click="tomeeting()" class="title bgc bgc2">
          <span class="indeximg">
            <img :src="imgpath.index1" alt />
          </span>
          {{$t('m.GoingOn')}}({{meetingTotal}})
          <Icon style="float:right;margin-top:14px" type="ios-arrow-forward"></Icon>
        </div>
        <div class="itemlist spebgc">
          <p :key="index" @click="tomeetingdetail(item.id,true)" v-for="(item,index) in meeting">
            <span>{{item.meeting_name}}</span>
            <span
              class="right"
              v-if="item.canControl"
              @click.stop="tomeetact(item.cf_id,item.mcuId,item.cfIdInWeMeet,item.cf_host,item.create_user)"
            >
              {{$t('m.ControlMeeting')}}
              <img :src="imgpath.nowmeet" alt style="width:0.2rem;cursor:pointer" />
            </span>
          </p>
        </div>
      </div>
      <div :class="{contentitem:true,ge:!meetingwill.length}">
        <div @click="toforthcomeing()" class="title bgc bgc2">
          <span class="indeximg">
            <img :src="imgpath.index2" alt />
          </span>
          {{$t('m.ComingSoon')}}({{meetingwillTotal}})
          <Icon style="float:right;margin-top:14px;" type="ios-arrow-forward"></Icon>
        </div>
        <div class="itemlist spebgc">
          <p
            :key="index"
            @click="tomeetingdetail(item.id,false)"
            v-for="(item,index) in meetingwill.slice(0,3)"
          >
            <span class="width">{{item.meeting_name}}</span>
            <span class="right width">
              <!-- <span class="time">{{item.meeting_date | getdata}}</span>
              <span class="realtivetime">{{item.meeting_date | gettime}}</span> -->
              <span class="time">{{gettime(item.meeting_date)}}</span>
              <span class="realtivetime">{{gettime(item.meeting_date)}}</span>
            </span>
          </p>
        </div>
      </div>
      <div :class="{contentitem:true,ge:!meetinghistory.length}">
        <div @click="tohistorymeeting()" class="title bgc bgc2">
          <span class="indeximg">
            <img :src="imgpath.index3" alt />
          </span>
          {{$t('m.HistoryHeld')}}({{meetinghistoryTotal}})
          <Icon style="float:right;margin-top:14px;" type="ios-arrow-forward"></Icon>
        </div>
        <div class="itemlist spebgc">
          <p
            :key="index"
            @click="tomeetingdetail(item.id,false)"
            v-for="(item,index) in meetinghistory.slice(0,3)"
          >
            <span class="width">{{item.meeting_name}}</span>
            <span class="right width">
              <span class="time">{{item.meeting_date | getdata}}</span>
              <!-- <span class="realtivetime">{{item.meeting_date | gettime}}</span> -->
              <span class="realtivetime">{{gettime(item.meeting_date)}}</span>
            </span>
          </p>
        </div>
      </div>
      <div :class="{contentitem:true,ge:!meetinghistoryplay.length}">
        <div @click="tohistoryplaymeeting()" class="title bgc bgc2">
          <span class="indeximg">
            <img :src="imgpath.index4" alt />
          </span>
          {{$t('m.ConferenceOnDemand')}}({{meetinghistoryplayTotal}})
          <Icon style="float:right;margin-top:14px;" type="ios-arrow-forward"></Icon>
        </div>
        <div class="itemlist spebgc">
          <p :key="index" v-for="(item,index) in meetinghistoryplay.slice(0,3)">
            <span class="width">
              <a :href="item.liveurl" class="acolor" target="_blank">{{item.meeting_name}}</a>
            </span>
            <span class="right width">
              <span class="time">{{item.meeting_date|getdata}}</span>
              <!-- <span class="realtivetime" style="float:right">{{item.meeting_date|gettime}}</span> -->
              <span class="realtivetime" style="float:right">{{gettime(item.meeting_date)}}</span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <Iframe :src="src" @iframeclose="iframeclose" v-if="iframeshow"></Iframe>
  </div>
</template>
<script>
import Header from "../header/header";
import {
  getNowMeetingListByDepartmentId,
  selectConfList,
  beforeCreateMeeting
} from "../../assets/js/url";
import Iframe from "./iframe";  
  
export default {
  name: "forgetpassword",
  data() {
    return {
      meeting: [],
      meetingwill: [],
      meetinghistory: [],
      meetinghistoryplay: [],
      meetingTotal: 0,
      meetingwillTotal: 0,
      meetinghistoryTotal: 0,
      meetinghistoryplayTotal: 0,
      i: 1000001,
      iframeshow: false,
      src: "",
      start: 0,
      login: "",
      timer: null
    };
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    move() {
      return this.i % 4;
    },
    showYTReturn(){
      if(window.sessionStorage.getItem('fromYT')){
        window.history.pushState({title:'ytlogin'},"ytlogin", "#"); 
      }
      return window.sessionStorage.getItem('fromYT')
    }
  },

  filters: {
    getdata(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const year = data.getFullYear();
      const mouth =
        data.getMonth() + 1 < 10
          ? "0" + (data.getMonth() + 1)
          : data.getMonth() + 1;
      const day = data.getDate() < 10 ? "0" + data.getDate() : data.getDate();
      return year + "/" + mouth + "/" + day;
    },
    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const datanow = new Date();
      if (data.getTime() > datanow.getTime()) {
        if (data.getFullYear() > datanow.getFullYear()) {
          return data.getFullYear() - datanow.getFullYear() + this.$t('m.AfterYear');
        }
        if (data.getMonth() > datanow.getMonth()) {
          return data.getMonth() - datanow.getMonth() + this.$t('m.AfterMonth');
        }
        if (data.getDate() > datanow.getDate()) {
          return data.getDate() - datanow.getDate() + this.$t('m.AfterDay');
        }
        if (data.getHours() > datanow.getHours()) {
          return data.getHours() - datanow.getHours() + this.$t('m.AfterHour');
        }
        if (data.getMinutes() > datanow.getMinutes()) {
          return data.getMinutes() - datanow.getMinutes() + this.$t('m.AfterMinute');
        }
      } else {
        if (data.getFullYear() < datanow.getFullYear()) {
          return Math.abs(data.getFullYear() - datanow.getFullYear()) + this.$t('m.BeforeYear');
        }
        if (data.getMonth() < datanow.getMonth()) {
          return Math.abs(data.getMonth() - datanow.getMonth()) + this.$t('m.BeforeMonth');
        }
        if (data.getDate() < datanow.getDate()) {
          return Math.abs(data.getDate() - datanow.getDate()) + this.$t('m.BeforeDay');
        }
        if (data.getHours() < datanow.getHours()) {
          return Math.abs(data.getHours() - datanow.getHours()) + this.$t('m.BeforeHour');
        }
        if (data.getMinutes() < datanow.getMinutes()) {
          return Math.abs(data.getMinutes() - datanow.getMinutes()) + this.$t('m.BeforeMinute');
        }
      }
    }
  },
  components: {
    Header,
    Iframe
  },
  mounted() {

    // const $t = this.$t
    // console.log(this.$t('m.ConferenceOnDemand'))
    
    document.title = window.localStorage.getItem("pageTitle")?window.localStorage.getItem("pageTitle"):'';
    this.touchmove();

    window.addEventListener("popstate", this.popstate, false);
  },
  // beforeRouteUpdate(to,from,next){
  //       console.log('routeupdated')
  //       next(false)
  //   },
  activated() {
    if(window.sessionStorage.getItem('fromYT')){
      setTimeout(()=>{
        this.getall();
      },100)
    }
    
    this.getall();
    this.timer = setInterval(() => {
      this.getall();
    }, 10000);
  },
  deactivated() {
    this.$destroy();
    clearInterval(this.timer);
    this.timer = null;
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    window.sessionStorage.removeItem('indexupdated')
    // window.removeEventListener("popstate",this.popstate)
  },
  methods: {

    gettime(value) {
      const data = new Date(value.split(".")[0].replace(/\-/g, "/"));
      const datanow = new Date();
      if (data.getTime() > datanow.getTime()) {
        if (data.getFullYear() > datanow.getFullYear()) {
          return data.getFullYear() - datanow.getFullYear() + this.$t('m.AfterYear');
        }
        if (data.getMonth() > datanow.getMonth()) {
          return data.getMonth() - datanow.getMonth() + this.$t('m.AfterMonth');
        }
        if (data.getDate() > datanow.getDate()) {
          return data.getDate() - datanow.getDate() + this.$t('m.AfterDay');
        }
        if (data.getHours() > datanow.getHours()) {
          return data.getHours() - datanow.getHours() + this.$t('m.AfterHour');
        }
        if (data.getMinutes() > datanow.getMinutes()) {
          return data.getMinutes() - datanow.getMinutes() + this.$t('m.AfterMinute');
        }
      } else {
        if (data.getFullYear() < datanow.getFullYear()) {
          return Math.abs(data.getFullYear() - datanow.getFullYear()) + this.$t('m.BeforeYear');
        }
        if (data.getMonth() < datanow.getMonth()) {
          return Math.abs(data.getMonth() - datanow.getMonth()) + this.$t('m.BeforeMonth');
        }
        if (data.getDate() < datanow.getDate()) {
          return Math.abs(data.getDate() - datanow.getDate()) + this.$t('m.BeforeDay');
        }
        if (data.getHours() < datanow.getHours()) {
          return Math.abs(data.getHours() - datanow.getHours()) + this.$t('m.BeforeHour');
        }
        if (data.getMinutes() < datanow.getMinutes()) {
          return Math.abs(data.getMinutes() - datanow.getMinutes()) + this.$t('m.BeforeMinute');
        }
      }
    },


    popstate(e) { 
      // console.log(this.$route)
      if(location.pathname=='/index' && window.sessionStorage.getItem('fromYT')){
          location.reload();
      }
      // if(location.pathname=='/ytlogin' && window.sessionStorage.getItem('fromYT')){
      //     location.href = 'https://sys.apiins.com/';
      // }
    },
    iframeclose() {
      this.iframeshow = false;
    },
    touchmove() {
      const _this = this;
      const mybody = document.getElementById("warpcontent");
      let startX, startY, moveEndX, moveEndY, X, Y;
      mybody.addEventListener("touchstart", function(e) {
        //e.preventDefault();
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
      });
      mybody.addEventListener("touchmove", function(e) {
        e.preventDefault();
      });
      mybody.addEventListener("touchend", function(e) {
        //e.preventDefault();
        moveEndX = e.changedTouches[0].pageX;
        moveEndY = e.changedTouches[0].pageY;
        X = moveEndX - startX;
        Y = moveEndY - startY;
        if (X > 20) {
          _this.i++;
        } else if (X < -20) {
          _this.i--;
        }
      });
    },
    tohistory() {
      this.$router.push({ path: "/historymeeting" });
    },
    tohistoryplaymeeting() {
      this.$router.push({ path: "/historyplaymeeting" });
    },
    tochoicepeople() {
      this.$router.push({
        path: "/userlist",
        query: {
          canChoose: false
        }
      });
    },
    tomeetingtemplate() {
      this.$router.push({ path: "/meetingtemplate" });
    },
    toterminalcontrol() {
      this.$router.push({
        name: "terminalcontrolPctest",
        query: {
          name: "cfterminal", //用这个字段区分  进入终端管理
          toattendmeeting: "attendmeeting"
        },
        params: {
          meeting_vrmId: 0,
          creatingTime: ""
        }
      });
    },
    toanpai() {
      this.$router.push({ path: "/attendmeeting" });
    },
    toattendmeeetlist() {
      //this.$router.push({ path: "/attendmeetinglist" });
	  this.$router.push({ path: "/forthcomeing" });
    },

    toforthcomeing() {
      this.$router.push({ path: "/forthcomeing" });
    },
    tomeeting() {
      this.$router.push({ path: "/forthmeetingvmr" });
    },
    tohistorymeeting() {
      this.$router.push({ path: "/historymeeting" });
      // location.reload();
    },
    tohistoryplaymeeting() {
      this.$router.push({ path: "/historyplaymeeting" });
    },
    tomeetingdetail(item, showAddTerminal) {
      this.$router.push({
        name: "meetingdetail",
        query: {
          meetinguuid: item,
          showAddTerminal: showAddTerminal //详情页是否显示扫二维码入会按钮
        }
      });
    },
    getmeetinglist: function() {
      this.$http
        .post(getNowMeetingListByDepartmentId, {
          useruuid: window.sessionStorage.getItem("UUID"),
          pageNo: 1,
          pagesize: 3
        })
        .then(
          res => {
            if (res.data.status == 2000) {
              this.meeting = res.data.data || [];
              this.meetingTotal = res.data.total;
            }
          },
          err => {}
        );
    },
    getmeetwilllist() {
      this.$http
        .post(selectConfList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          type: 2,
          start: this.start,
          pagesize: 10
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.meetingwill = res.data.data || [];
            this.meetingwillTotal = res.data.total;
          }
        });
    },
    getmeethistorylist() {
      this.$http
        .post(selectConfList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          type: 3,
          start: this.start,
          pagesize: 10
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.meetinghistory = res.data.data || [];
            this.meetinghistoryTotal = res.data.total;
          }
        });
    },
    getmeetplaylist() {
      this.$http
        .post(selectConfList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          type: 4,
          start: this.start,
          pagesize: 10
        })
        .then(res => {
          if (res.data.status == 2000) {
            this.meetinghistoryplay = res.data.data || [];
            this.meetinghistoryplayTotal = res.data.total;
          }
        });
    },
    getall() {
      this.getmeetinglist();
      this.getmeetwilllist();
      this.getmeethistorylist();
      this.getmeetplaylist();
    },
    tomeetact(cf_id, mcuId, cfIdInWeMeet, host, createuser) {
      this.$http
        .post(beforeCreateMeeting, { time: Date.parse(new Date()) })
        .then(res => {
          if (res.data.status == 2000) {
            let data = res.data.data;
            this.showRecordAndLive = data.showRecordAndLive;
          }
        });
      if (window.sessionStorage.getItem("userStatus")) {
        this.$router.push({
          path: "/meetingact",
          query: {
            cfIdInWeMeet: cfIdInWeMeet,
            cf_id: cf_id,
            mcuId: mcuId
          }
        });
      } else {
        if (
          window.sessionStorage.getItem("UUID") != host &&
          window.sessionStorage.getItem("UUID") != createuser
        ) {
          this.$toast(this.$t('m.YouNoRight'));
          return;
        }
        this.$router.push({
          path: "/meetingact",
          cfIdInWeMeet: cfIdInWeMeet,
          query: {
            cf_id: cf_id,
            mcuId: mcuId
          }
        });
      }
    },
    iframeshowact(src) {
      this.src = src;
      this.iframeshow = true;
    },

    retrunHome(){
      window.sessionStorage.removeItem('fromYT');
      window.location.href = 'https://sys.apiins.com/'
    }
  }
}
</script>
<style scoped>
.index {
  width: 100%;
}

.menu {
  width: 100%;
  box-sizing: border-box;
  height: 0.8rem;
  padding: 0.1rem 0 0;
  text-align: center;
  float: left;
  position: absolute;
  background: #fff;
  left: 100%;
  top: 0;
  transition: all 0.5s;
}

.menu.center {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
}

.menu.left {
  position: absolute;
  left: -100%;
  top: 0;
}

.warp {
  width: 100%;
  overflow: hidden;
  margin-top: 0.1rem;
}
.lancewarp {
  width: 100%;
  overflow: hidden;
  margin-top: 0.1rem;
  margin-left: 0.2rem;
}
.warpcentent {
  width: 100%;
  /* transition: all 0.5s; */
  position: relative;
  height: 0.8rem;
}

.menuitem {
  width: 0.75rem;
  display: inline-block;
  text-align: center;
  line-height: 0.2rem;
  vertical-align: top;
}

.menuitem img {
  height: 0.36rem;
  width: 0.32rem;
}

.menuitem span {
  margin-top: 0.05rem;
  font-size: 0.14rem;
  width: 100%;
  display: inline-block;
}

.contentitem.ge {
  margin-bottom: 0.1rem;
}

.contentitem .title {
  padding: 0 0.15rem;
  height: 0.41rem;
  line-height: 0.41rem;
  color: #fff;
  font-size: 0.15rem;
}

.contentitem .title img {
  height: 0.14rem;
  width: 0.14rem;
  vertical-align: middle;
  margin-top: -4px;
  margin-right: 5px;
}

.itemlist p {
  padding: 0 0.15rem;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
}

.itemlist p:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.1);
}

.right {
  float: right;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
  cursor: pointer;
}

.right img {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-left: 0.2px;
}

.width {
  display: inline-block;
  width: 49%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: underline;
}

.time,
.relativetime {
  display: inline-block;
}

.time {
  width: 60%;
  text-align: center;
}

.relativetime {
  width: 40%;
  text-align: right;
}

.realtivetime {
  float: right;
}

.iconfont {
  font-size: 0.18rem;
  margin-right: 0.05rem;
}

.iconfont2 {
  font-size: 0.22rem;
}

.indeximg {
  display: inline-block;
  width: 0.3rem;
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: left;
}

.indeximg > img {
  width: 0.2rem !important;
  vertical-align: middle;
  height: 0.2rem !important;
}
 
.ytclose {
  height: 50px;
  line-height: 50px;;
  background:#32af66 url(../../assets/images/icons/return.png) no-repeat 12px 50%;
  background-size:32px auto ;
  margin: 0;
  padding-left: 42px;
  color:#fff;
  font-size:18px
}
</style>




// WEBPACK FOOTER //
// src/components/content/index.vue